import React ,{Component} from 'react';
import TooManyCodesRequestedPage from './../../pages/accountLinking/tooManyCodesRequested'

class TooManyCodesRequested extends Component{

    render(){

        return(

            <div className="Rectangle-100">

            <TooManyCodesRequestedPage/>

            </div>

            );
    }
}

export default TooManyCodesRequested